/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedNullSearchResults_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "BuySharedNullSearchResults_buyPage";
};
export type BuySharedNullSearchResults_buyPage$data = BuySharedNullSearchResults_buyPage;
export type BuySharedNullSearchResults_buyPage$key = {
    readonly " $data"?: BuySharedNullSearchResults_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedNullSearchResults_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedNullSearchResults_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '97a5d28a908c5e831169aa05b8e1ed96';
export default node;
